/**
 * abilityVfxHawkshot — Ashe E Hawkshot spirit-hawk missile (SP-03).
 */
export function buildHawkshot(THREE, spec) {
  const group = new THREE.Group();
  const s = spec.scale || 1.15;
  const bodyMat = mat(THREE, spec.color || 0xf1f5f9, 0.95);
  const accent = mat(THREE, 0x38bdf8, 0.75);

  const body = new THREE.Mesh(
    new THREE.ConeGeometry(0.22 * s, 1.1 * s, 8).rotateX(Math.PI / 2),
    bodyMat
  );
  group.add(body);

  const head = new THREE.Mesh(new THREE.SphereGeometry(0.14 * s, 8, 8), bodyMat);
  head.position.z = 0.55 * s;
  group.add(head);

  for (let i = 0; i < 2; i += 1) {
    const wing = new THREE.Mesh(
      new THREE.BoxGeometry(0.55 * s, 0.04 * s, 0.28 * s),
      accent
    );
    wing.position.set((i === 0 ? -1 : 1) * 0.35 * s, 0.05 * s, -0.05 * s);
    group.add(wing);
  }

  const glow = new THREE.Mesh(
    new THREE.SphereGeometry(0.32 * s, 8, 8),
    mat(THREE, 0xbae6fd, 0.35)
  );
  group.add(glow);

  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.55 * s, 0.7 * s, 20).rotateX(-Math.PI / 2),
    accent
  );
  ring.position.y = -0.15 * s;
  group.add(ring);

  group.userData = { shape: 'hawkshot' };
  return group;
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
